// Matches /:slug/unsubscribe.
// baseServer: "/search/" is set in vite.config.ts — vike strips the prefix
// before route matching, so urlPathname is already /:slug/unsubscribe.
const route = "/@slug/unsubscribe";
export default route;
